/**
 * Amazon Music has two address forms in every store country:
 *
 * - `music.amazon.<tld>/...`, for example `music.amazon.de/albums/B0...`.
 * - `amazon.<tld>/music/...`, the player of the shop, for example
 *   `amazon.co.jp/music/player/tracks/B0...`. The share button of the app gives this form.
 *
 * Any other `amazon.<tld>` address is the shop, not Amazon Music.
 */
const AMAZON_MUSIC_HOST = /^music\.amazon\.(?:com?\.)?[a-z]{2,3}$/;
const AMAZON_SHOP_HOST = /^amazon\.(?:com?\.)?[a-z]{2,3}$/;

/** True for a `music.amazon.<tld>` host. The host is in lower case with no `www.`. */
export function isAmazonMusicHost(host: string): boolean {
  return AMAZON_MUSIC_HOST.test(host);
}

/** True for an Amazon Music address. The host is in lower case with no `www.`. */
export function isAmazonMusicAddress(host: string, path: string): boolean {
  if (isAmazonMusicHost(host)) {
    return true;
  }
  const lowerPath = path.toLowerCase();
  return AMAZON_SHOP_HOST.test(host) && (lowerPath === '/music' || lowerPath.startsWith('/music/'));
}
